import {Button, FormControl, Spinner} from "react-bootstrap";

function PaymentTestSimulationPanel({payPaymentId, onChangePayPaymentId, onSuccessClick, onErrorClick, testProcessing}) {
    return (
        <div style={{
            padding: "12px 16px",
            backgroundColor: "#f8f9fa",
            borderTop: "1px solid #dee2e6"
        }}>
            <div style={{fontSize: 13, fontWeight: 600, color: "#495057", marginBottom: 4}}>
                Test – 3D Secure Simülasyonu
            </div>
            <div style={{fontSize: 12, color: "#6c757d", marginBottom: 10}}>
                Ödeme tablosundaki kayıt ID'sini girerek sonucu simüle edin.
            </div>
            <div style={{display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap"}}>
                <span style={{fontSize: 13, fontWeight: 500, color: "#495057", whiteSpace: "nowrap"}}>
                    Ödeme ID:
                </span>
                <FormControl
                    type="text"
                    placeholder="örn. 12345"
                    size="sm"
                    style={{width: 140}}
                    value={payPaymentId}
                    disabled={testProcessing}
                    onChange={onChangePayPaymentId}
                />
                <Button
                    variant="success"
                    size="sm"
                    onClick={onSuccessClick}
                    disabled={testProcessing || !payPaymentId}
                    style={{minWidth: 130}}
                >
                    {testProcessing ? (
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                    ) : "Ödeme Başarılı"}
                </Button>
                <Button
                    variant="danger"
                    size="sm"
                    onClick={onErrorClick}
                    disabled={testProcessing || !payPaymentId}
                    style={{minWidth: 130}}
                >
                    {testProcessing ? (
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                    ) : "Ödeme Başarısız"}
                </Button>
            </div>
        </div>
    );
}

export default PaymentTestSimulationPanel;
